import React from 'react';
import { Search, X, Filter } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';

const activityTypes = [
  { value: 'meeting', label: 'Reunión' },
  { value: 'call', label: 'Llamada' },
  { value: 'email', label: 'Email' },
  { value: 'reflexion', label: 'Reflexión' },
  { value: 'evento', label: 'Evento' }
];

const ActivitySearchBar = ({
  searchQuery,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  ownerFilter,
  onOwnerFilterChange,
  dateFromFilter,
  onDateFromFilterChange,
  dateToFilter,
  onDateToFilterChange,
  owners,
  resultCount,
  onClear,
  hasActiveFilters
}) => {
  return (
    <div className="space-y-3 mb-4" data-testid="activity-search-bar">
      {/* Search Input */}
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Buscar en título, resumen, notas..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10"
            data-testid="activity-search-input"
          />
        </div>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClear}
            className="shrink-0"
            data-testid="clear-filters-btn"
          >
            <X className="w-4 h-4 mr-1" />
            Limpiar
          </Button>
        )}
      </div>

      {/* Filters Row */}
      <div className="flex flex-wrap gap-2 items-center">
        <Filter className="w-4 h-4 text-muted-foreground" />
        
        {/* Type Filter */}
        <Select value={typeFilter} onValueChange={onTypeFilterChange}>
          <SelectTrigger className="w-[130px] h-8 text-xs" data-testid="type-filter">
            <SelectValue placeholder="Tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los tipos</SelectItem>
            {activityTypes.map(type => (
              <SelectItem key={type.value} value={type.value}>{type.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Owner Filter */}
        <Select value={ownerFilter} onValueChange={onOwnerFilterChange}>
          <SelectTrigger className="w-[140px] h-8 text-xs" data-testid="owner-filter">
            <SelectValue placeholder="Responsable" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="unassigned">Sin asignar</SelectItem>
            {owners.map(owner => (
              <SelectItem key={owner} value={owner}>{owner}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Date From */}
        <Input
          type="date"
          value={dateFromFilter}
          onChange={(e) => onDateFromFilterChange(e.target.value)}
          className="w-[130px] h-8 text-xs"
          placeholder="Desde"
          data-testid="date-from-filter"
        />

        {/* Date To */}
        <Input
          type="date"
          value={dateToFilter}
          onChange={(e) => onDateToFilterChange(e.target.value)}
          className="w-[130px] h-8 text-xs"
          placeholder="Hasta"
          data-testid="date-to-filter"
        />
      </div>

      {/* Results Count */}
      {hasActiveFilters && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span>Mostrando</span>
          <Badge variant="secondary">{resultCount}</Badge>
          <span>resultado{resultCount !== 1 ? 's' : ''}</span>
          {searchQuery && (
            <span>para "<strong className="text-foreground">{searchQuery}</strong>"</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ActivitySearchBar;
